function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32



//////////////////
// WEBPACK FOOTER
// ./~/browserify-aes/incr32.js
// module id = 375
// module chunks = 1